import { DEFAULT_PAGE_SIZE } from '../constants/AiappConstants';

const getPageSize = (level: string): number => {
    const pageSize = localStorage.getItem(`${level}`) !== null && localStorage.getItem(`${level}`) !== undefined ? localStorage.getItem(`${level}`) : `${DEFAULT_PAGE_SIZE}`;
    return pageSize ? parseInt(pageSize) : DEFAULT_PAGE_SIZE;
};

export default getPageSize;
